import React, { memo } from 'react';
import BlockMarkdown from './BlockMarkdown';
import ClaimSupportFooter from '../ClaimSupportFooter';
import { extractBlockItems } from './structuredBlockUtils';
import styles from './structuredResponse.module.css';

function KeyFindingsBlock({ block, renderContext }) {
    const items = extractBlockItems(block);
    if (!items.length) return null;

    return (
        <section className={styles.keyFindingsBlock} aria-label={block.title || 'Key findings'}>
            {block.title ? <h3 className={styles.blockTitle}>{block.title}</h3> : null}
            <ul className={styles.keyFindingsList}>
                {items.map((item, index) => {
                    const title = item.title || item.label;
                    const content = item.content || item.markdown || item.description || item.text;
                    if (!title && !content) return null;
                    return (
                        <li key={item.id || `finding-${index}`} className={styles.keyFindingItem}>
                            {title ? <div className={styles.keyFindingTitle}>{title}</div> : null}
                            {content ? <BlockMarkdown content={content} {...renderContext} /> : null}
                        </li>
                    );
                })}
            </ul>
            <ClaimSupportFooter block={block} renderContext={renderContext} />
        </section>
    );
}

export default memo(KeyFindingsBlock);
